function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "question-path-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M768.3,415.3a6.742,6.742,0,1,0,7.076-6.078A6.585,6.585,0,0,0,768.3,415.3Z",
  transform: "translate(-768.293 -409.217)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "question-path-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M732.636,50.7a1.993,1.993,0,0,1-1.885-2.1l.256-4.684c.57-10.518,5.471-12.667,11.15-15.15a52.933,52.933,0,0,0,6.19-3.063,6.581,6.581,0,0,0,3.074-5.079c.224-4.1-2.671-6.709-7.012-6.944-5.626-.307-7.484,4.4-7.922,7.275a2,2,0,0,1-2.379,1.677l-9-1.881a1.988,1.988,0,0,1-1.594-2.156C724.922,7.307,733.646-.293,744.855.314c12.171.662,20.549,9.512,19.922,21.041a19.947,19.947,0,0,1-15.493,18.473c-3.673.862-4.771,1.941-4.927,4.82l-.447,4.747a1.992,1.992,0,0,1-2.092,1.809Z",
  transform: "translate(-723.497 -0.28)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-134 -106)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 49.5,
  cy: 49.5,
  r: 49.5,
  transform: "translate(134 106)",
  fill: "#80ad6a"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(164.342 121.198)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.341 57.883)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M768.3,415.3a6.742,6.742,0,1,0,7.076-6.078A6.585,6.585,0,0,0,768.3,415.3Z",
  transform: "translate(-768.293 -409.217)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#question-path-1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1277.818,
  height: 2268.126,
  transform: "translate(-976.685 -1878.774)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M732.636,50.7a1.993,1.993,0,0,1-1.885-2.1l.256-4.684c.57-10.518,5.471-12.667,11.15-15.15a52.933,52.933,0,0,0,6.19-3.063,6.581,6.581,0,0,0,3.074-5.079c.224-4.1-2.671-6.709-7.012-6.944-5.626-.307-7.484,4.4-7.922,7.275a2,2,0,0,1-2.379,1.677l-9-1.881a1.988,1.988,0,0,1-1.594-2.156C724.922,7.307,733.646-.293,744.855.314c12.171.662,20.549,9.512,19.922,21.041a19.947,19.947,0,0,1-15.493,18.473c-3.673.862-4.771,1.941-4.927,4.82l-.447,4.747a1.992,1.992,0,0,1-2.092,1.809Z",
  transform: "translate(-723.497 -0.28)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#question-path-2)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1277.818,
  height: 2268.126,
  transform: "translate(-970.344 -1820.891)",
  fill: "#fff"
})))));

var SvgReactionQuestion = function SvgReactionQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactionQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reaction-question.53d2168a.svg";
export { ForwardRef as ReactComponent };